export default function FreeSpace() {
  return <div className={'free-space'} data-id={'free-space'} />;
}
